import talendFlowService from '@/service/talent-flow';
import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';

const moBility = observable({
  yearList: [],
  activeTime: '',
  talentActive: 'inflow',
  roleLeftActive: 'role',
  roleRightActive: 'role',
  cateList: [],
  activeCate: '',
  talendList: <any>{},
  roleList: <any>{}
});

// 获取人才流动时间

const getTalendFlowTime = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const res = await talendFlowService.TalendFlowTime(parmes);
  const local: any = await localforage.getItem('flow') || {};
  runInAction(() => {
    moBility.yearList = res.years;
    moBility.activeTime = local.activeTime || (!isEmpty(res) ? res?.years[res.years.length - 1] : '');
  })
});



// 切换职能流动

const changeRoleLeftActive = action(async (val: string) => {
  runInAction(() => {
    moBility.roleLeftActive = val;
  })
  const local: any = await localforage.getItem('flow') || {};
  local['roleLeftActive'] = val;
  localforage.setItem('flow', local);
})


// 切换职能流动

const changeRoleRightActive = action(async (val: string) => {
  runInAction(() => {
    moBility.roleRightActive = val;
  })
  const local: any = await localforage.getItem('flow') || {};
  local['roleRightActive'] = val;
  localforage.setItem('flow', local);
})

// 切换人才流动

const changeTalentActive = action(async (val: string) => {
  runInAction(() => {
    moBility.talentActive = val;
  })
  const local: any = await localforage.getItem('flow') || {};
  local['talentActive'] = val;
  localforage.setItem('flow', local);
})

// 切换时间

const changeActiveTime = action(async (val: string) => {
  const param = {
    industry: moIndex.industry.code,
    time: val,
    category: moBility.activeCate,
  };
  runInAction(() => {
    moBility.activeTime = val;
  })
  const res = await talendFlowService.TalendFlowIndustry(param)
  const params = {
    industry: moIndex.industry.code,
    time: val,
    category: moBility.activeCate,
  };
  const result = await talendFlowService.FunctionFlow(params);
  runInAction(() => {
    moBility.talendList = res;
    moBility.roleList = result;
  })
  const local: any = await localforage.getItem('flow') || {};
  local['activeTime'] = val;
  localforage.setItem('flow', local);
})

// 切换职能

const changeActiveCate = action(async (val: string) => {
  const param = {
    industry: moIndex.industry.code,
    time: moBility.activeTime,
    category: val,
  };
  const res = await talendFlowService.TalendFlowIndustry(param)
  const params = {
    industry: moIndex.industry.code,
    time: moBility.activeTime,
    category: val,
  };
  const result = await talendFlowService.FunctionFlow(params);
  runInAction(() => {
    moBility.activeCate = val;
    moBility.talendList = res;
    moBility.roleList = result;
  })
})

// 获取职能数据

const getTalendFlowCategory = action(async () => {
  const params = {
    industry: moIndex.industry.code,
    time: moBility.activeTime,
  };
  const res = await talendFlowService.TalendFlowCategory(params);
  const list = res.map((res: any) => {
    const item = { value: res.name, code: res.code };
    return item;
  })
  runInAction(() => {
    moBility.cateList = list;
    moBility.activeCate = !isEmpty(list) ? list[0].code : '';
  });
});


// 获取人才流动数据-行业
const getTalendFlowIndustry = action(async () => {
  const param = {
    industry: moIndex.industry.code,
    time: moBility.activeTime,
    category: moBility.activeCate,
  };
  const res = await talendFlowService.TalendFlowIndustry(param)
  runInAction(() => {
    moBility.talendList = res;
  });
});

// 职能流入流出

const getFunctionFlow = action(async () => {
  const param = {
    industry: moIndex.industry.code,
    time: moBility.activeTime,
    category: moBility.activeCate,
  };
  const res = await talendFlowService.FunctionFlow(param);
  runInAction(() => {
    moBility.roleList = res
  });
});

// 页面初始化

const mobilityInit = action(async () => {
  const local: any = await localforage.getItem('flow') || {};
  runInAction(() => {
    moBility.talentActive = local.talentActive || 'inflow';
    moBility.roleLeftActive = local.roleLeftActive || 'role';
    moBility.roleRightActive = local.roleRightActive || 'role';
  })
  await getTalendFlowTime();
  await getTalendFlowCategory();
  await Promise.all([
    getTalendFlowIndustry(),
    getFunctionFlow(),
  ]);
});

export default moBility;
export {
  mobilityInit, changeActiveTime, changeRoleLeftActive, changeTalentActive, changeActiveCate,
  changeRoleRightActive
};
